export default __webpack_public_path__ + "static/media/detail_small_4_4.34cb81c8.png";